import { isHoveredOver, handleMouseHover, handleMouseLeave } from '@/graph_parts/common_template_support'
import { positionBinding, bindingFromHighlight } from '@/graph_parts/binding'
import { validationNotEmpty } from '@/graph_parts/validation'
import { finishDrop } from '@/graph_parts/moving'
import { amber900, grey50, grey400, grey700, grey800, orangeA100, orange500, blueGrey600, lightBlue500 } from '@/utils/constants'
import * as go from 'gojs'
var $ = go.GraphObject.make

function highlightNode (e, node, highlight) {
  if (!node.data.group) {
    node.isHighlighted = highlight
  }
}

function hasFieldSpecifier (i) {
  return typeof i.fieldSpecifier !== 'undefined' && i.fieldSpecifier.trim() !== ''
}

function createNodeTemplate (isTester, includeAdornments, allowChange, showExpanderButton) {
  const r = $(go.Node, 'Spot',
    {
      mouseDragEnter: allowChange ? function (e, node, prev) { highlightNode(e, node, true) } : null,
      mouseDragLeave: function (e, node, next) { highlightNode(e, node, false) },
      mouseDrop: finishDrop,
      mouseHover: handleMouseHover,
      mouseLeave: handleMouseLeave,
      selectable: allowChange,
      shadowBlur: 8,
      shadowColor: grey700,
      selectionAdorned: false,
      locationSpot: go.Spot.TopLeft
    },
    positionBinding(),
    new go.Binding('layerName', 'isSelected', function (sel) { return sel ? 'Foreground' : '' }).ofObject(),
    new go.Binding('isShadowed', '', i => { return i.data.isInPalette === false && i.isTopLevel }).ofObject(),
    new go.Binding('opacity', '', x => x.isIncludedInQuery && !x.isParentExcludedInQuery && !x.isHidden ? 1 : 0.4)
  )
  const mainPanel = $(go.Panel, 'Auto',
    $(go.Shape, 'RoundedRectangle',
      {
        fill: 'transparent',
        stroke: 'transparent',
        strokeWidth: 3,
        parameter1: 1,
        name: 'NODE_RECTANGLE'
      },
      new go.Binding('stroke', '', x => { return isHoveredOver(x) ? amber900 : 'transparent' })
    ),
    $(go.Panel, 'Horizontal',
      { stretch: go.GraphObject.Horizontal },
      $(go.Panel, 'Auto',
        new go.Binding('visible', '', i => hasFieldSpecifier(i)),
        $(go.Shape, 'RoundedLeftRectangle',
          { fill: blueGrey600, strokeWidth: 1, stroke: blueGrey600, parameter1: 2 },
          bindingFromHighlight('fill', blueGrey600, blueGrey600, orangeA100, blueGrey600),
          bindingFromHighlight('stroke', blueGrey600, blueGrey600, orangeA100, blueGrey600)
        ),
        $(go.TextBlock,
          {
            margin: new go.Margin(5, 7, 5, 7),
            editable: allowChange,
            isMultiline: false,
            font: 'normal 14px Roboto',
            stroke: 'white',
            textEdited: function (textBlock, oldText, newText) {
              textBlock.diagram.selection.each(function (node) {
                textBlock.diagram.model.setDataProperty(node.data, 'fieldSpecifier', newText)
              })
            }
          },
          new go.Binding('text', 'fieldSpecifier').makeTwoWay()
        )
      ),
      $(go.Panel, 'Auto',
        $(go.Shape,
          { figure: 'RoundedRectangle', fill: 'white', strokeWidth: 1, stroke: grey400, parameter1: 2 },
          new go.Binding('figure', '', i => { return hasFieldSpecifier(i) ? 'RoundedRightRectangle' : 'RoundedRectangle' }),
          bindingFromHighlight('fill', 'white', 'white', orangeA100, grey800),
          bindingFromHighlight('stroke', grey400, grey400, orangeA100, grey800)
        ),
        $(go.TextBlock,
          {
            name: 'TERM_TEXT_BLOCK',
            margin: new go.Margin(5, 7, 5, 7),
            editable: allowChange,
            isMultiline: false,
            font: 'normal 14px Roboto',
            textValidation: validationNotEmpty
          },
          bindingFromHighlight('stroke', blueGrey600, blueGrey600, 'white', grey50),
          new go.Binding('text', 'text').makeTwoWay()
        )
      )
    )
  )
  r.add(mainPanel)
  r.add(
    $('TreeExpanderButton',
      { alignment: go.Spot.Bottom, alignmentFocus: go.Spot.Top },
      { visible: true }
    )
  )

  if (includeAdornments) {
    r.add(
      $(go.Panel, 'Auto',
        { alignment: new go.Spot(1, 0, 8, 8), alignmentFocus: go.Spot.BottomRight },
        new go.Binding('visible', '', x => x.isTopLevel).ofObject(),
        $(go.Shape,
          {
            figure: 'RoundedRectangle',
            fill: lightBlue500,
            strokeWidth: 1,
            stroke: 'transparent',
            parameter1: 5
          },
          new go.Binding('fill', '', x => x.data._showingCount ? lightBlue500 : 'transparent').ofObject()
        ),
        $(go.TextBlock,
          {
            isMultiline: false,
            font: 'normal 12px Roboto',
            stroke: 'white'
          },
          new go.Binding('stroke', '', x => x.data._showingCount ? 'white' : 'transparent').ofObject(),
          new go.Binding('text', '', x => { return x.data._showingCount ? x.data._count : '' }).ofObject()
        )
      )
    )
    r.add(
      $(go.Panel, 'Auto',
        { alignment: new go.Spot(1, 0, 5, 15), alignmentFocus: go.Spot.BottomRight },
        $(go.Shape,
          { figure: 'Circle', fill: orange500, strokeWidth: 1, stroke: 'transparent', parameter1: 5, width: 15 },
          new go.Binding('fill', '', x => x.data._duplicated ? orange500 : 'transparent').ofObject()
        ),
        $(go.TextBlock,
          {
            isMultiline: false,
            font: 'bold 13px',
            stroke: 'white',
            textAlign: 'center'
          },
          new go.Binding('stroke', '', x => x.data._duplicated ? 'white' : 'transparent').ofObject(),
          new go.Binding('text', '', x => { return x.data._duplicated ? '!' : '' }).ofObject()
        )
      )
    )
  }

  return r
}

export { createNodeTemplate }



// WEBPACK FOOTER //
// ./src/graph_parts/node_template.js